// i18n area 'cluster' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.hu-HU.meta.json.
import type { enUS } from './cluster'

export const huHU: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garanciális hozzáférések',
      subtitle: 'A csomópont szervizajtaja: a csak olvasható hozzáférés ideiglenes jelszóval és a vészhelyzeti fiók a széf jelszavával',
      readOnlyTitle: 'Csak olvasható hozzáférés (trantor)',
      stateNone: 'zárva',
      stateGranted: 'nyitva',
      stateGrantedPending: 'megadva — alkalmazás a csomóponton',
      grantedBy: 'Megadta',
      grantedAt: 'Megadva',
      expiresAt: 'Lejár',
      reason: 'Indok',
      endedAt: 'Zárva',
      endedReason: {
        revoked: 'visszavonva',
        expired: 'lejárt (TTL)',
        reboot: 'a csomópont újraindítása',
        failed: 'nem alkalmazva (a feladat meghiúsult)'
      },
      grant: 'Csak olvasható hozzáférés megadása…',
      grantTitle: 'Csak olvasható hozzáférés megadása',
      grantSubmit: 'Megadás',
      grantError: 'A megadást elutasították',
      grantConfirm: 'A TVirt ideiglenes jelszót generál a «trantor» rendszerfelhasználónak (csak olvasás: journal és diagnosztika, sudo nélkül), és egy feladattal beállítja a csomóponton. A jelszó CSAK egyszer jelenik meg, a megerősítéskor; megszűnik a lejáratkor, visszavonáskor vagy a csomópont következő újraindításakor.',
      reasonLabel: 'Indok',
      reasonHint: 'Miért nyitod ki az ajtót: bekerül a megadásba, az auditba és a naplóba',
      ttlLabel: 'Időtartam',
      ttlHours: '{n} óra',
      revoke: 'Csak olvasható hozzáférés visszavonása…',
      revokeTitle: 'Csak olvasható hozzáférés visszavonása',
      revokeSubmit: 'Visszavonás',
      revokeError: 'A visszavonást elutasították',
      revokeConfirm: 'A megadás azonnal megszűnik, és egy feladat újra zárolja a «trantor» felhasználót a csomóponton: az ideiglenes jelszó érvényét veszti.',
      passwordTitle: 'Csak olvasható jelszó',
      passwordOnce: 'Ez a jelszó CSAK egyszer jelenik meg: másold ki most. Sehol nincs elmentve, és nem olvasható vissza — ha elveszíted, add meg újra.',
      passwordUser: 'Felhasználó',
      passwordLabel: 'Jelszó',
      passwordHint: 'Érvényes eddig: {until}, vagy a csomópont következő újraindításáig; használható, amint a megadási feladat befejeződött. Hozzáférés: ssh trantor@<a csomópont címe>.',
      emergencyTitle: 'Utolsó vészhelyzeti hozzáférés (trantor-emergency)',
      lastLogin: '{time}, {via} útján, innen: {from}',
      lastLoginNone: 'nem észlelt',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konzol',
        sudo: 'sudo',
        unknown: 'ismeretlen'
      },
      emergencyHint: 'A «trantor-emergency» vészhelyzeti fiók (teljes sudo) mindig engedélyezett a csomópont telepítésekor generált és a széfben őrzött jelszóval: a TVirt nem ismeri, nem rotálja és nem állítja helyre. Minden bejelentkezés itt és az eseménynaplóban jelenik meg.'
    },
    nodeFirewall: {
      tab: 'Tűzfal',
      title: 'A csomópontok tűzfala',
      subtitle: 'Annak az nftables rulesetnek az alapállása, amelyet minden csomópont önmagára alkalmaz — a csomópont egyetlen tűzfala (a firewalld le van tiltva)',
      modeLabel: 'Alapállás',
      mode: {
        disabled: 'Letiltva — nincs ruleset a csomópontokon',
        permissive: 'Megengedő — számol és naplóz, semmit sem dob el',
        enforced: 'Kikényszerítve — csak a származtatott nyilvántartás jut be'
      },
      hint: {
        disabled: 'Ahogy ma: a csomópontok nem hordoznak semmilyen rulesetet. Válts megengedőre, hogy ELOLVASD, mi lenne eldobva, mielőtt eldobnák.',
        permissive: 'Minden csomópont policy accept mellett alkalmazza a saját származtatott rulesetjét: amit a kikényszerített mód eldobna, azt megszámolja és naplózza (journal-előtag: «tvirt-node would-drop:»). Semmi sincs blokkolva.',
        enforced: 'Minden csomópont policy drop mellett alkalmazza a saját származtatott rulesetjét: ssh és API bárhonnan, store / live migration / overlay / Ceph csak a tagoktól, a hálózati szolgáltatások listenerei a kiszolgált hálózatról. Minden váltás egy megerősítendő apply — az a csomópont, amely nem tud megerősíteni, magától visszaáll.'
      },
      confirmTitle: 'Kikényszeríted a csomópontok tűzfalát?',
      confirmBody: 'Minden csomópont megerősítéssel alkalmazza a rulesetet: a határidőn belül az új szabályokon át megszondázza a backendet, a store-t és az ssh-t, majd megerősít — különben magától visszaáll az előző rulesetre. Előbb olvasd el a megengedő mód számlálóit a csomópontokon.',
      confirmSubmit: 'Kikényszerítés',
      confirmCancel: 'Mégse',
      lensTitle: 'A csomópont tűzfala',
      loadError: 'Nem sikerült betölteni a csomópont tűzfalának lencséjét',
      noReport: 'Erről a csomópontról még nincs tűzfaljelentés — a worker a következő körben jelent',
      firewalldActive: 'Ezen a csomóponton firewalld fut: a csomóponti tűzfal nem hajlandó mellette alkalmazódni (maszkold a firewalld szolgáltatást)',
      conditionUnconfirmed: 'Még nincs megerősített ruleset — a csomópont nyitva van',
      conditionRolledBack: 'Az utolsó apply visszaállt — ugyanazt a generációt nem próbálja újra, amíg a nyilvántartás meg nem változik vagy az alapállást újra át nem váltják',
      lastError: 'Utolsó hiba',
      posture: 'Alapállás',
      observedAt: 'Megfigyelve',
      desiredGeneration: 'Kívánt generáció',
      componentTitle: 'Csomóponti komponens',
      componentSubtitle: 'tvirt-node-firewall — bootkor alkalmazza a megerősített rulesetet, a meg nem erősítettet magától visszaállítja',
      componentAbsent: 'A komponens még nem jelentett',
      phase: 'Fázis',
      phases: {
        none: 'Soha nem alkalmazva',
        applied: 'Alkalmazva — megerősítésre vár',
        confirmed: 'Megerősítve',
        rolledBack: 'Visszaállt'
      },
      generation: 'Generáció',
      appliedAt: 'Alkalmazás ideje',
      confirmedAt: 'Megerősítés ideje',
      deadline: 'A rollback határideje',
      lastRollback: 'Utolsó rollback',
      registryTitle: 'Származtatott nyilvántartás',
      registrySubtitle: 'A portok, amelyeket ez a csomópont megnyit, osztály és eredet szerint — a klaszterből származtatva, sosem kézzel szerkesztve',
      registryEmpty: 'Semmi sincs származtatva — az alapállás letiltva megerősített ruleset nélkül, vagy még nincs jelentés',
      colClass: 'Osztály',
      colPort: 'Port',
      colSource: 'Forrás',
      colOrigin: 'Eredet',
      classes: {
        public: 'Nyilvános',
        internode: 'Csomópontok közötti',
        tenant: 'Tenant'
      },
      sourceMembers: 'csak a tagok',
      sourceAnywhere: 'bárhonnan',
      sourceBridge: 'a(z) {iface} interfészen'
    },
    derivationDerived: 'származtatott',
    derivationDiverged: 'eltért',
    derivationDerivedTip: 'A hálózati dokumentum a(z) {fabric} fabricból SZÁRMAZTATOTT és még egyezik a renderrel a jelenlegi bemeneteken — kattintson a derivációs tervért.',
    derivationDivergedTip: 'A(z) {fabric} fabricból való deriváció megváltozott az utolsó apply után (fabric, kábelezés, szerepek vagy hivatkozások) — kattintson a függő différt.',
    derivationRetiring: {
      one: '{n} cím ürül',
      other: '{n} cím ürül'
    },
    standaloneHint: 'Ennek a csomópontnak nincs klasztere: még nem lett telepítve. A klaszterek az installációkor jönnek létre VAGY csatlakoznak — az egyik tag Szerverek táblájában generált tokent kell az installernek megetetni (dev: db:init-cluster / db:init-join).',
    reducedHint: 'A jogosultságaid egy scope-ra terjednek ki, nem az egész klaszterre: a flotta leltára — csomópontok, beállítások és eszközök — csak a klaszter adminisztrátorai számára látható.',
    phaseReady: 'Kész',
    phaseForming: 'Formálódik',
    storeMembers: 'A store tagjai',
    watermark: 'Konvergenciaküszöb',
    configGeneration: 'Konfigurációgeneráció',
    converged: 'szinkronban',
    behind: 'lemaradva — {m} / {n}',
    revision: 'Revízió',
    rolesTitle: 'Hálózati szerepkörök',
    rolesSubtitle: 'Tagonkénti címek minden forgalmi osztályhoz — a konnektivitás a host-hálózatban él',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'a managementet örökli',
    settingsTitle: 'Beállítások',
    settingsSubtitle: 'Klaszterszintű biztonsági szabályzat — minden csomópont a saját helyi replikájából értékeli ki',
    taskRetentionTitle: 'Feladatmegőrzés',
    taskRetentionSubtitle: 'Egységes GC minden feladatra — az életkoron vagy a plafonon túli befejezett feladatok begyűjtésre kerülnek, a futók soha',
    taskRetentionMaxAge: 'Maximális életkor (nap)',
    taskRetentionMaxCount: 'Feladatok maximális száma',
    eventRetentionTitle: 'Eseménymegőrzés',
    eventRetentionSubtitle: 'A napló GC-je — a feladatokétól független politika: a feladat sor, az esemény emlékezet',
    eventRetentionMaxAge: 'Maximális kor (nap)',
    eventRetentionMaxCount: 'Tárolt események maximális száma',
    spaceThresholdsTitle: 'Helyküszöbök',
    spaceThresholdsSubtitle: 'Mikor kerül a telítődő tároló a naplóba (és az értesítésekbe)',
    spaceLowPct: 'Figyelmeztetés ettől (% használt)',
    spaceCriticalPct: 'Kritikus ettől (% használt)',
    spaceOrderError: 'A kritikus nem lehet a figyelmeztetés alatt',
    spaceThresholdsHint: 'Csak a belépések állíthatók be: a kilépést a motor származtatja, 5 ponttal minden küszöb alatt, hogy a határon álló tároló soha ne váljon metronómmá',
    failoverReserveTitle: 'Failover-tartalék',
    failoverReserveSubtitle: 'N+1 befogadásvezérlés — szabadon tartott RAM, hogy a klaszter csomópontok elvesztése után újraindíthassa a saját terhelését',
    failoverReserveTolerate: 'Hány csomópont elvesztését kell elviselni',
    failoverReserveOff: '0 — a tartalék kikapcsolva: egyetlen indítás sem lesz failover-kapacitás miatt elutasítva',
    failoverReserveOn: 'A tartalékot megcsapoló indítás egy 412-vel lesz elutasítva, amely elmagyarázza a számokat',
    networkShapingTitle: 'Sávszélesség-méltányosság',
    networkShapingSubtitle: 'Az uplinkenkénti shaping-fa három tipológiai súlya — csak versengés alatt hatnak',
    networkShapingRest: 'A maradék súlya (vezérlősík, storage, replikák)',
    networkShapingOverlay: 'Az overlay hálózatok súlya',
    networkShapingLiveMigration: 'A live migration súlya',
    networkShapingHint: 'Garantált részesedés = súly / a három összege (alapértelmezés 300 / 100 / 200, mindegyik 1 és 10000 között); tétlen linken bármely osztály elviheti a teljes sávszélességet',
    debugModeTitle: 'Debug-mód',
    debugModeSubtitle:
      'Részletes hibák a GUI általános üzeneteiben — hogy lásd a valódi okot, amikor egy „sikertelen” művelet valójában sikerült',
    debugModeLabel: 'Debug-mód bekapcsolva',
    debugModeOn: 'Az általános hibaüzenetek hozzáfűzik a mögöttes okot — belső részletek minden üzemeltető számára láthatók',
    debugModeOffHint: 'Kikapcsolva — az általános hibaüzenetek megmaradnak általánosnak, belső részletek nélkül',
    nodeDetailsAction: 'Csomópont részletei',
    node: {
      docTitle: 'Csomópont',
      notFound: 'A csomópont nem található',
      tabOverview: 'Áttekintés',
      tabStats: 'Statisztikák',
      tabNetwork: 'Hálózat',
      tabSettings: 'Helyi beállítások',
      identityTitle: 'Identitás',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Konfigurációrevízió',
      versionsTitle: 'Megfigyelt verziók',
      heartbeatSubtitle: 'Az utolsó állapot, amelyet a csomópont önmagáról jelentett',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-modell',
      memoryTitle: 'Memória',
      hugePagesTitle: 'Óriáslapok',
      hugePagesPool: '{size}: {free} szabad / {total}',
      hugePagesNone: 'Nincs készlet',
      hugePagesNoneHint: 'A csomóponton nincs fenntartott óriáslap: az ezt kérő VM-ek itt nem indulhatnak. A készletet a csomóponton kell deklarálni, a kernel hugepagesz és hugepages paramétereivel, vagy az nr_hugepages írásával.',
      usageTitle: 'Jelenlegi használat',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nem megfigyelt — nincs friss minta',
      statsNoData: 'Nincs adat az intervallumban — a csomópont idősorait maga a csomópont mintavételezi és helyben szolgálja ki.',
      observedTitle: 'Megfigyelt állapot',
      observedSubtitle: 'A csomópont helyi szolgáltatásai és assetjei, ahogy a worker látja őket'
    },
    editRolesTitle: 'Hálózati szerepkörök szerkesztése',
    memberNode: 'Csomópont',
    memberIp: 'IP-cím',
    addMember: 'Tag hozzáadása',
    lmInherit: 'A management címeinek használata',
    roleIpHint: 'Tag hozzáadása és eltávolítása szabad; egy meglévő tag IP-jének helyben cseréje elutasításra kerül — az IP-migrációs folyamat egy későbbi körben érkezik.',
    roleError: 'A szerepköröket nem sikerült frissíteni',
    nodesTitle: 'Csomópontok',
    addNodeTitle: 'Csomópont hozzáadása a klaszterhez',
    addNode: 'Csomópont hozzáadása',
    addNodeError: 'A csomópontot nem sikerült előregisztrálni',
    nodeName: 'A csomópont neve',
    nodeNameHint: 'egyeznie kell az installációkor választott névvel',
    nodeIp: 'Management-IP',
    colName: 'Név',
    colPhase: 'Fázis',
    colServices: 'Szolgáltatások',
    colWatermark: 'Watermark',
    colLastSeen: 'Utolsó kapcsolat',
    colUps: 'UPS',
    upsCordonChip: 'UPS-kordon',
    upsCordonTip: 'A csomópont az UPS-e tényei alapján ítélte el magát ({time}): magától oldja fel a kordont, ha a hálózat stabil és az akkumulátor feltöltött',
    upsUnreachable: 'UPS nem elérhető',
    upsOnBattery: 'Akkumulátorról',
    upsOnLine: 'Hálózatról',
    upsLowBattery: 'alacsony akkumulátor',
    upsNoEstimateChip: 'üzemidő nincs becsülve',
    upsNoEstimateTip: 'Az UPS nem tesz közzé üzemidő-becslést: a csomópontot csak az UPS LB (alacsony akkumulátor) jelzője ítéli el — hangolja a battery.runtime.low / LB értéket magán az UPS-en',
    upsLaneTip: 'UPS leállítási pálya {since} óta: elítélve: {by}',
    upsUnit: 'egység',
    upsStatus: 'NUT-állapot',
    upsLoad: 'terhelés',
    upsOnBatterySince: 'akkumulátorról ettől',
    upsOnLineSince: 'hálózatról ettől',
    upsError: 'hiba',
    upsObservedAt: 'megfigyelve',
    upsNone: 'egyetlen UPS-egység sem szolgálja ki ezt a csomópontot',
    upsBy: {
      runtime: 'üzemidő a küszöb alatt',
      lowBattery: 'az UPS LB jelzője',
    },
    upsLane: {
      evacuate: 'evakuálás',
      local: 'helyben leállítás',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'vendégek leállítása',
      stoppingServices: 'szolgáltatások leállítása',
      poweredOff: 'kikapcsolva',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-egységek és küszöbök: a csomópont üzemidő ≤ küszöb vagy LB jelző (mindig figyelembe véve) esetén elítélve, folytatás hiszterézissel',
    upsRuntimeThreshold: 'Üzemidő-küszöb (s)',
    upsRuntimeThresholdHint: 'Akkumulátorról, becsült üzemidő ≤ küszöb esetén a csomópont sorrendben leáll (alapértelmezés 300)',
    upsResumeStable: 'Hálózat stabil ennyi ideig (s)',
    upsResumeStableHint: 'Folytatás csak legalább ennyi másodperce folyamatos hálózattal (alapértelmezés 60)',
    upsResumeCharge: 'Minimális töltöttség folytatáskor (%)',
    upsResumeChargeHint: 'És az akkumulátor legalább erre a százalékra feltöltve (alapértelmezés 25)',
    upsPolicyNote: 'Az UPS LB (alacsony akkumulátor) jelzője mindig elítél és nem kapcsolható ki; az akkumulátoron töltött időre nincs küszöb. Minden egység felülírhatja a három számot.',
    upsUnitNew: 'új egység',
    upsUnitSelectors: '{n} címkeválasztó (csak CLI)',
    upsUnitName: 'Egység neve',
    upsUnitMode: 'Mód',
    upsModeExternal: 'külső (idegen upsd)',
    upsModeManaged: 'kezelt (csomóponthoz csatlakoztatott UPS)',
    upsUnitUpsname: 'NUT-név (upsname)',
    upsUnitHost: 'upsd-kiszolgáló',
    upsUnitAttachedNode: 'Csatlakoztatott csomópont',
    upsUnitDriver: 'NUT-illesztőprogram',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Illesztőprogram eszköze',
    upsUnitDeviceHint: 'az ups.conf port= sora: üres = auto',
    upsUnitPort: 'upsd-port',
    upsUnitServedNodes: 'Kiszolgált csomópontok',
    upsUnitServedNodesHint: 'csomópontnevek vesszővel elválasztva (a címkeválasztók a CLI-n át mennek)',
    upsUnitOverrideHint: 'üres = fürt alapértelmezése',
    upsUnitAdd: 'Egység hozzáadása',
    unreachableSince: 'Elérhetetlen — utolsó heartbeat: {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Az overlay-dataplane még nem valósította meg az aktuális overlay-konfigurációt',
    overlaysError: 'Az utolsó overlay-egyeztetési menet sikertelen: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Csatlakozásra vár',
      'joining': 'Csatlakozik',
      'member': 'Tag'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Csak most látható — másold ki azonnal, többé nem lesz olvasható',
    copy: 'Másolás',
    copied: 'Másolva',
    close: 'Bezárás',
    revokeTitle: 'Előregisztráció visszavonása',
    revoke: 'Visszavonás',
    revokeError: 'A regisztrációt nem sikerült visszavonni',
    promote: 'Előléptetés store memberré',
    demote: 'A store-member szerepkör eltávolítása',
    troubleshoot: 'Hibaelhárítás',
    promoteTitle: 'Előléptetés store memberré',
    demoteTitle: 'A store-member szerepkör eltávolítása',
    promoteHint: 'A csomópont belép a YugabyteDB masterek kvórumába. Az igazi HA három store membert igényel.',
    demoteHint: 'A csomópont kilép a masterek kvórumából, és leállítja a store-szolgáltatásait.',
    storeError: 'A store-member módosítása el lett utasítva',
    attest: 'Kikapcsoltnak nyilvánítás…',
    attestTitle: 'Csomópont kikapcsoltnak nyilvánítása',
    attestSubmit: 'Kikapcsoltnak nyilvánítás',
    attestConfirm: 'Saját felelősségedre kikapcsoltnak nyilvánítod ezt a csomópontot: egy valójában élő csomópont kikapcsoltnak nyilvánítása kettős futású VM-eket kockáztat. A feladatai sikertelenné válnak, és a VM-jeinek authority-je átruházhatóvá válik.',
    attestError: 'A nyilvánítás el lett utasítva',
    attestedChip: 'kikapcsoltnak nyilvánítva',
    maintenanceChip: 'karbantartás',
    guestToolsChip: 'TVirt Guest Tools (csomóponti helyi ISO-asset)',
    maintenanceEnter: 'Karbantartás bekapcsolása',
    maintenanceExit: 'Karbantartás kikapcsolása',
    maintenanceEnterTitle: 'Karbantartás bekapcsolása',
    maintenanceExitTitle: 'Karbantartás kikapcsolása',
    maintenanceEnterSubmit: 'Karbantartás bekapcsolása',
    maintenanceExitSubmit: 'Karbantartás kikapcsolása',
    maintenanceEnterConfirm: 'A csomópont lezárásra és kiürítésre kerül: a hálózati szolgáltatások és az App-példányok, amelyek authorityját birtokolja, átkerülnek (a példányok hidegen: itt leállítva és learatva, a célcsomóponton újra létrehozva — leállás), a futó VM-ek élőben migrálnak, ahol lehet, egyébként szabályosan leállnak, a folyamatban lévő feladatok befejeződnek, az új munka vár, a leállított VM-ek pedig elvesztik az authorityjukat — a Proximity a következő indításkor újra elhelyezi őket. A karbantartás végén semmi sem tér vissza magától.',
    maintenanceExitConfirm: 'A csomópont újra munkába áll, és a Proximity ismét számításba veszi az elhelyezésnél. A VM-ek csak akkor térnek vissza, amikor elindítják őket.',
    maintenanceError: 'A karbantartási kérés el lett utasítva',
    maintenancePlanTitle: 'Evakuációs terv',
    maintenancePlanLoading: 'Az evakuációs terv számítása…',
    maintenancePlanError: 'Az evakuációs terv nem tölthető be — a kiürítés így is átköltöztet, ahol lehet, és leállítja a többit.',
    maintenancePlanEmpty: 'Ezen a csomóponton nincs mit kiüríteni — nincs aktív hálózati szolgáltatás, nincs futásra kért App-példány, nincs futó VM.',
    maintenancePlanSummary: '{migrate} objektum migrál (VM-ek, hálózati szolgáltatások, App-példányok), {stop} leáll vagy a helyén marad.',
    maintenancePlanReserve_ok: 'Failover-tartalék a kiürítés után: ép — {headroom} GiB indítható marad {n} csomópont elvesztését is elviselve.',
    maintenancePlanReserve_eroded: 'Failover-tartalék a kiürítés után: majdnem elfogyott — a {n} csomóponthibára szabadon tartott {reserve} GiB-ból csak {headroom} GiB marad.',
    maintenancePlanReserve_exhausted: 'Failover-tartalék a kiürítés után: KIMERÜLT — {headroom} GiB hiányzik a {n} csomóponthiba elviseléséhez szükséges {reserve} GiB-ból. Amíg ez a csomópont kint van, az új VM-indítások el lesznek utasítva.',
    maintenancePlanReserve_unknown: 'Failover-tartalék a kiürítés után: nem számítható — egyetlen megmaradt csomópont sem deklarálta a memóriáját.',
    maintenancePlanReserveHugePages: 'Óriáslapok ({size}) a kiürítés után — szabad: {free} / {capacity}, tartalékként kért: {reserve}.',
    maintenancePlanActionMigrate: 'költözik',
    maintenancePlanActionMigrateWarning: 'költözik (soft szabály sérül)',
    maintenancePlanActionStop: 'leáll',
    maintenancePlanActionBlocked: 'blokkolva',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'hálózati szolgáltatás',
    maintenancePlanKindApp: 'App-példány',
    maintenancePlanColdMove: 'Hideg áthelyezés: a pod itt leáll és learatásra kerül, a célcsomópont workere pedig újra létrehozza — leállás a cél-worker következő passáig.',
    caFingerprint: 'A klaszter CA-jának ujjlenyomata',
    staleChip: 'nem friss',
    troubleshootTitle: 'A store hibaelhárítása',
    restartStore: 'A store-szolgáltatások újraindítása',
    restartHint: 'Ha a store rakoncátlankodik, indítsd újra a szolgáltatásait. Haladó — óvatosan használandó.',
    restartQueued: 'Újraindítási feladat sorba állítva',
    restartError: 'A szolgáltatásokat nem sikerült újraindítani',
    svcActive: 'aktív',
    svcWanted: 'kívánt, nem aktív',
    svcStopped: 'áll',
    noServices: 'Nincs jelentett szolgáltatás'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Az egész klaszter GPU-leltára modell szerint csoportosítva — a csomópontonként megfigyelt kártyák, a megjelölt regisztrációkkal és a címkéikkel',
    usbTitle: 'USB-erőforrások',
    usbSubtitle: 'Az egész klaszter USB-leltára modell szerint csoportosítva — a csomópontonként megfigyelt eszközök, mindkét modell regisztrációival (eszközönként, portonként) és a címkéikkel',
    markedChip: '{n} TVirt által használható',
    orphanChipGpu: '{n} árva',
    orphanChipUsb: '{n} árva',
    colNode: 'Csomópont',
    colRegistration: 'Regisztráció',
      noRegsHint: 'Nincs regisztráció — az eszközt a csomópont dialógusából lehet „TVirt által használhatónak” jelölni (Csomópontok › csomópont › Beállítások).',
      colDevice: 'Eszköz',
      colObserved: 'Megfigyelt',
      colRegs: 'Regisztrációk',
      regsNone: 'nincs',
      colPci: 'PCIe-cím',
      colIdentity: 'Identitás / port',
      colClasses: 'Osztályok (címkék)',
      colActions: 'Műveletek',
      manageOnNode: 'Kezelés a(z) {node} csomóponton (a megjelölés a csomópont dialógusában él)',
      introTitle: 'A TVirt© által használható USB- és PCIe-eszközök klaszterleltára.',
      introStep1: '1. A csomópontok maguktól felfedezik a saját GPU-ikat és USB-eszközeiket (számbavétel a heartbeatben).',
      introStep2: '2. Egy eszközt a CSOMÓPONT dialógusából lehet „TVirt által használhatónak” jelölni (Csomópontok › csomópont › Beállítások) — a megjelölés a vfio-hoz köti, és itt regisztrálja.',
      introStep3: '3. Itt adod a regisztrációknak az OSZTÁLYAIKAT címkékkel (pl. gpu_class=compute): a VM-ek követelményei egy osztályt kérnek majd, és az ütemező olyan csomópontot választ, amelyen van kompatibilis szabad eszköz.',
    colMode: 'Mód',
    colState: 'Állapot',
    colNotes: 'Jegyzetek',
    colTags: 'Címkék',
    modeDevice: 'eszközönként',
    modePort: 'portonként',
    usable: 'használható',
    orphanGpu: 'árva',
    orphanUsb: 'árva',
    hubChip: 'hub',
    orphanPortsTitle: 'Portonkénti regisztrációk csatlakoztatott eszköz nélkül — csatlakoztass újra egy eszközt, vagy vedd le a jelölésüket a csomópontról',
    gpusEmpty: 'Egyetlen csomóponton sem figyeltek még meg GPU-t',
    usbEmpty: 'Egyetlen csomóponton sem figyeltek még meg USB-eszközt'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Minimális jelszóhossz',
    sessionIdle: 'Munkamenet tétlenségi időkorlátja (perc)',
    lockoutThreshold: 'Zárolás ennyi sikertelen próbálkozás után',
    lockoutDuration: 'A zárolás időtartama (perc)',
    keyboardLayout: 'Billentyűzetkiosztás',
    keyboardLayoutHint: 'pl. it, en-us — üresen a QEMU defaultja',
    syslogEndpoint: 'Syslog-végpont',
    syslogEndpointHint: 'host:port — üresen a továbbítás kikapcsol',
    syslogTls: 'TLS',
    maxQueued: 'Sorban álló feladatok maximuma',
    concurrency: 'A worker konkurrenciája',
    concurrencyHint: 'A worker menet közben alkalmazza',
    notesTitle: 'Jegyzetek',
    save: 'Mentés',
    saved: 'Beállítások mentve',
    saveError: 'A beállításokat nem sikerült menteni'
  },
  localSettings: {
    derivedChip: 'származtatott',
    derivedTip: 'Ez a device a fabric-deriváció TULAJDONA (H2): a szerkesztő nem nyúl hozzá — módosítsa a fabricot (vagy a kábelezést) és alkalmazza újra, vagy vegye vissza alább.',
    takeOwnership: 'Tulajdon átvétele',
    takeOwnershipTitle: 'Tulajdon átvétele (take-ownership)',
    takeOwnershipConfirm: '{name} elhagyja a fabric blokkot és újra KÉZI device lesz, amelyet ez a szerkesztő kormányoz. A node eltért lesz, és a következő derivációs apply elutasít rajta (manualConflict), amíg át nem nevezi vagy el nem távolítja — vagy ki nem javítja a fabricot.',
    nodeSettingsTitle: 'Csomópont-beállítások',
    nodeSettingsSubtitle: 'Amit ez a csomópont alkalmaz — feladatsor, konzol, naplótovábbítás — plusz a címkéi és a jegyzetei',
    baseTitle: 'Host-tartalékok (TVirt Proximity)',
    baseSubtitle: 'A host operációs rendszerének fenntartott CPU és RAM — az empirikus kapacitás bemenetei, amellyel a Proximity a VM-eket elhelyezi',
    baseMemory: 'Alap-RAM (MiB)',
    baseMemoryHint: 'Megfigyelt összes: {total} MiB. VM-eknek használható = összes − alap − az ide helyezett bekapcsolt VM-ek RAM-ja.',
    baseMemoryHintNoTotal: 'VM-eknek használható = megfigyelt összes − alap − az ide helyezett bekapcsolt VM-ek RAM-ja.',
    baseCpu: 'Alap CPU-magok',
    baseCpuHint: 'Megfigyelt logikai CPU-k: {total}. Csak rangsorolási súlyként számítanak — a vCPU-overcommit normális.',
    baseCpuHintNoTotal: 'Csak rangsorolási súlyként számítanak — a vCPU-overcommit normális.',
    baseHint: 'A RAM a szigorú befogadási kapu: az a VM, amely nem fér bele a használható RAM-ba, beszédes hibával lesz elutasítva. Emeld meg az alapot azokon a hostokon, amelyek store-tagokat vagy Ceph-démonokat futtatnak.',
    placementTitle: 'Fizikai pozíció',
    placementSubtitle: 'Hol áll fizikailag ez a szerver — egyszer deklarálva, bármihez kelljen',
    placementHint: 'A pozíció vezérli minden olyan Ceph-klaszter CRUSH-hierarchiáját, amelynek OSD-je van ezen a szerveren: egy módosítás mentése feladatokkal igazítja újra a térképeiket (host → rack → … → root). A részleges deklarációk legálisak — az üres szintek összecsuknak. A nevek az egész térképen közösek: két szerver ugyanabban a rackben ugyanazt a racknevet deklarálja.',
    placementNameInvalid: 'DNS-biztos név (kisbetűk, számjegyek, kötőjelek)',
    placementEmpty: 'Üresen = nem deklarált',
    placementLevel: {
      chassis: 'Ház',
      rack: 'Rack',
      row: 'Sor',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Terem',
      datacenter: 'Adatközpont',
      zone: 'Zóna',
      region: 'Régió'
    },
    cablingTitle: 'Kábelezés',
    cablingSubtitle: 'Melyik switchporthoz csatlakozik az egyes interfészek kábele — a deklaráció a csomóponton él (Annex O.9)',
    cablingHint: 'NIC-enként egy kábel, portonként egy kábel az egész flottában (az API a birtokos megnevezésével utasít el). LAGG-tagport felé kábelezni legális — ez a bond eset: a jövőbeli származtatás LACP-ként fogja renderelni.',
    cablingInterface: 'Interfész',
    cablingNotCabled: '— nincs bekötve —',
    cablingNoInterfaces: 'Nincs megfigyelt hálózati interfész',
    disksTitle: 'Lemezek',
    disksSubtitle: 'Megfigyelt blokkeszközök — egyeztetési menetenként egy szkennelés; itt jelöld meg a Ceph OSD-ként használható lemezeket (N.15: az alkalmasság explicit)',
    colDataDisk: 'Adatlemez',
    dataDisksHint: 'Egy eszköz bepipálása OSD-ként használhatónak deklarálja; a sorozatszám az identitás-pinje — ha a lemez jelenti, a hardverből másolva, különben veretve (tvirt-…). A Ceph-regisztrációs dialógus csak a deklarált lemezeket kínálja fel.',
    diskDeclaredSerial: 'deklarált',
    diskNotObserved: 'deklarált, de nem megfigyelt — csatold újra az eszközt, vagy vedd ki a pipát',
    noDisks: 'Még nincs megfigyelt blokkeszköz',
    colSerial: 'Sorozatszám',
    colModel: 'Modell',
    colSize: 'Méret (GiB)',
    colDiskType: 'Típus',
    colInUse: 'Használatban',
    colObservedAt: 'Megfigyelve',
    diskInUse: 'használatban',
    diskFree: 'szabad',
    diskMounted: 'csatolva',
    diskPartitions: 'partíciók',
    passthroughTitle: 'Passthrough-eszközök',
    passthroughSubtitle: 'Megfigyelt GPU-k és USB-eszközök — itt jelöld meg, mit adhat át a TVirt a VM-eknek; a megjelölés regisztrálja az eszköz identitását (round U1+G1)',
    passthroughHint: 'A megjelölés regisztrálja az eszközt (egy stabil id — a címkék és az osztálykövetelmények célpontja). Egy megjelölt GPU TELJES IOMMU-csoportja egyben a vfio-pci-hez kötődik — azonnal elhagyja a hostot; a jelölés levétele visszaakasztja a natív drivert. USB-nél mindkét ratifikált modell létezik: eszközönként (vendor+termék, bárhová is dugják) és fizikai portonként (a VM-hez az érkezik, amit épp beledugtak). Az USB a megjelöléskor nem bindol — az attach a VM futásidejében történik.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'TVirt által használható',
    colGpu: 'GPU',
    colPciAddress: 'PCI-cím',
    colDriver: 'Driver',
    colVerdict: 'Ítélet',
    gpuEligible: 'Alkalmas',
    gpuIneligible: 'Nem alkalmas',
    gpuReason: {
      'no-iommu': 'az IOMMU nem aktív a hoston',
      'group-spans-slots': 'az IOMMU-csoport nem izolált: más slotokra is kiterjed',
      'multiple-display': 'az IOMMU-csoport nem izolált: egynél több videofunkció',
      'foreign-function': 'az IOMMU-csoport nem izolált: idegen funkciót tartalmaz'
    },
    vfioNotReady: 'Az IOMMU nem aktív ezen a hoston: egyetlen GPU sem alkalmas, amíg a host-platform nem engedélyezi (OEM ISO) — a TVirt futásidőben sosem nyúl a kernel argokhoz.',
    vfioMissingKernelArg: 'Az IOMMU nem aktív ezen a hoston: a firmware jelenti a VT-d/AMD-Vi-t (ACPI DMAR/IVRS tábla jelen van), de hiányzik a kernel arg — add hozzá az intel_iommu=on-t (Intel), vagy vedd ki az amd_iommu=off-ot (AMD) a kernel parancssorából, és indíts újra. A TVirt futásidőben sosem nyúl a kernel argokhoz.',
    vfioFirmwareDisabled: 'Az IOMMU nem aktív ezen a hoston: a VT-d/AMD-Vi le van tiltva a firmware-ben (nincs ACPI DMAR/IVRS tábla), vagy a CPU nem támogatja — engedélyezd a firmware setupjában, kernel arg nem tudja bekapcsolni. A TVirt futásidőben sosem nyúl a hosthoz.',
    gpuBindError: 'vfio-pci bind sikertelen — {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Tűzfal nem kezelt bridge-eken',
    firewallBridgesSubtitle: 'Az ezen a csomóponton kézzel épített bridge-ek, amelyek setupja hozzájárul a TVirt által renderelt tűzfal-chainekhez a csatlakoztatott vendég NIC-eken',
    firewallBridgesHint: 'A TVirt sosem nyúl az idegen bridge-hez — a chain a tap/veth-en horgonyoz, amely mindig a TVirté. A lista egy hozzájárulási kapu: a default-deny és az anti-spoof eltörheti azt, amit egy kézi setup elvár, ezért az itt NEM felsorolt, nem kezelt bridge-en lévő tűzfalas NIC beszédes hibával elutasításra kerül.',
    firewallBridgesEmpty: 'Ezen a csomóponton egyetlen nem kezelt bridge sem járul hozzá a TVirt által renderelt tűzfal-chainekhez.',
    firewallBridgeAdd: 'Bridge hozzáadása',
    firewallBridgeInvalid: 'Nem Linux interfésznév (1-15 karakter, perjel és szóköz nélkül)',
    firewallBridgeDuplicate: 'A név már szerepel a listán',
    colMarkDevice: 'Eszközönként',
    colMarkPort: 'Portonként',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'árva — regisztrált, de már nem észlelt: csatlakoztasd újra, vagy vedd le a jelölést',
    noGpus: 'Még nincs megfigyelt GPU',
    noUsb: 'Még nincs megfigyelt USB-eszköz',
    networkGeneration: 'Hálózati generáció',
    applied: 'Alkalmazva',
    converged: 'szinkronban',
    behind: 'lemaradva — {m} / {n}',
    notConfigured: 'nincs konfigurálva',
    rollbackBody: 'A(z) {gen} generáció alkalmazása sikertelen: {error}',
    rolledBackChip: 'rollback végrehajtva',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'A kezelt NIC-ek törzsadatai — a regisztráció MAGA a kezelési nyilatkozat: egy konfiguráció nélküli regisztrált NIC-hez nem nyúlunk (a clear-if explicit tisztának deklarálja), egy nem regisztrált eszközhöz sosem nyúlunk',
    addNic: 'NIC regisztrálása',
    addNicTitle: 'NIC regisztrálása (add-nic)',
    delNic: 'Kezelés befejezése',
    delNicTitle: 'Kezelés befejezése (del-nic)',
    delNicConfirm:
      'A(z) {name} kezelése véget ér: a törzsadat-bejegyzés és a konfigurációja törlődik, a TVirt-profil lekerül — az eszköz úgy marad, ahogy a Linux hagyja.',
    nicName: 'Az eszköz neve',
    nicMac: 'Állandó MAC-cím',
    nicMacHint: 'az állandó hardveres MAC — a TVirt Server Installer által rögzített stabil identitás',
    colObserved: 'Megfigyelt',
    nicObserved: 'megfigyelt',
    nicNotObserved: 'nem megfigyelt',
    nicMacMismatch: 'Eltérő MAC — megfigyelt: {mac}',
    noNics: 'Nincs regisztrált NIC — regisztrálj egy eszközt a kezelés megkezdéséhez',
    noManagedDevices: 'Nincs kezelt eszköz — regisztrálj előbb egy NIC-et, minden a törzsadatokra épül',
    inventoryTitle: 'Megfigyelt eszközök',
    inventorySubtitle: 'A csomópont workere minden egyeztetési menetben frissíti — a validálás ezen a leltáron ellenőrzi az eszközneveket',
    colDevice: 'Eszköz',
    colType: 'Típus',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Sebesség',
    colTopology: 'Topológia',
    colMtu: 'MTU',
    colAddresses: 'Címek',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'A LACP nem aggregál',
    noInventory: 'Eddig nincs jelentett eszköz',
    interfacesTitle: 'Interfészek',
    interfacesSubtitle:
      'A regisztrált NIC-ek és a deklarált logikai eszközök L3-konfigurációja — a set-if a teljes blokkot cseréli, az edit-if a tulajdonságokat igazítja, a clear-if kiüríti (explicit tisztítás)',
    colConfig: 'Kívánt konfiguráció',
    clean: 'tiszta',
    setIf: 'Címzés módosítása',
    setIfTitle: 'Címzés módosítása (set-if)',
    editIf: 'Tulajdonságok módosítása',
    editIfTitle: 'Tulajdonságok módosítása (edit-if)',
    clearIf: 'Konfiguráció kiürítése',
    clearIfTitle: 'Konfiguráció kiürítése (clear-if)',
    clearIfConfirm: 'Az interfész konfigurációja kiürül. A tiszta interfész az előfeltétele annak, hogy bond/bridge tagjaként vagy VLAN parentjeként szolgáljon.',
    ip4Mode: 'IPv4-mód',
    ip6Mode: 'IPv6-mód',
    modeUnconfigured: 'Nincs konfigurálva',
    modeStatic: 'Statikus',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-címek',
    ip6Addresses: 'IPv6-címek',
    addressesHint: 'CIDR, vesszővel elválasztva',
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-szerverek',
    dnsHint: 'vesszővel elválasztva — üresen a DNS nullázódik (a set-if a blokkot cseréli)',
    routes4: 'Statikus IPv4-útvonalak',
    routes6: 'Statikus IPv6-útvonalak',
    routeTo: 'Cél (CIDR)',
    routeVia: 'Via',
    addRoute: 'Útvonal hozzáadása',
    routesChip: 'útvonalak',
    mtu: 'MTU',
    mtuHint: 'üresen = a driver defaultja',
    vlansTitle: 'VLAN',
    addVlan: 'VLAN hozzáadása',
    addVlanTitle: 'VLAN hozzáadása (add-vlan)',
    delVlanTitle: 'VLAN törlése (del-vlan)',
    vlanParent: 'Parent interfész',
    vlanId: 'VLAN ID',
    vlanPreview: 'Az eszköz neve',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Nincs deklarált VLAN',
    bondsTitle: 'Bondok',
    addBond: 'Bond hozzáadása',
    addBondTitle: 'Bond hozzáadása (add-bond)',
    editBondTitle: 'Bond szerkesztése',
    editBond: 'Bond mentése',
    delBondTitle: 'Bond törlése (del-bond)',
    bondName: 'A bond neve',
    members: 'Tagok',
    membersHint: 'a tagoknak tiszta interfészeknek kell lenniük (L3-konfiguráció nélkül)',
    bondMode: 'Mód',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Elsődleges tag',
    rate: 'LACP-ráta',
    hash: 'Átviteli hash-szabályzat',
    colMembers: 'Tagok',
    colMode: 'Mód',
    noBonds: 'Nincs deklarált bond',
    bridgesTitle: 'Bridge-ek',
    addBridge: 'Bridge hozzáadása',
    addBridgeTitle: 'Bridge hozzáadása (add-bridge)',
    editBridgeTitle: 'Bridge szerkesztése',
    editBridge: 'Bridge mentése',
    delBridgeTitle: 'Bridge törlése (del-bridge)',
    bridgeName: 'A bridge neve',
    stp: 'STP',
    stpOn: 'STP aktív',
    stpOff: 'STP kikapcsolva',
    colStp: 'STP',
    noBridges: 'Nincs deklarált bridge',
    hostnameTitle: 'Hostnév',
    hostname: 'Hostnév',
    setHostname: 'Hostnév beállítása',
    setHostnameTitle: 'Hostnév beállítása (set-hostname)',
    hostnameHint: 'Csak OS-identitás — a csomópont klaszterbeli nevéhez nem nyúlunk',
    notSet: 'nincs beállítva',
    staticHostsTitle: 'Statikus hostbejegyzések',
    addStaticHost: 'Bejegyzés hozzáadása',
    addStaticHostTitle: 'Statikus hostbejegyzés hozzáadása',
    delStaticHostTitle: 'Statikus hostbejegyzés törlése',
    hostIp: 'IP-cím',
    hostNames: 'Nevek',
    hostNamesHint: 'vesszővel vagy szóközzel elválasztva',
    colIp: 'IP',
    colNames: 'Nevek',
    noStaticHosts: 'Nincs statikus hostbejegyzés',
    delConfirm: 'A(z) {name} eltávolítása a kívánt dokumentumból — a csomópont workere NetworkManager-checkpointtal és automatikus rollbackkel konvergál.',
    remove: 'Eltávolítás',
    opError: 'A hálózati műveletet a rendszer elutasította'
  }
}
